import React from 'react'
import ReactDOM from 'react-dom'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    Raven.captureException(error, { extra: errorInfo });
  }

  render() {
    if (this.state.error) {
      return (
        <div className="sentry" onClick={() => Raven.lastEventId() && Raven.showReportDialog()}>
          <img src={sentry_logo} className="img-fluid"/>
          <p>{I18n.t('sentry.message')}</p>
          <p className="action">{I18n.t('sentry.action')}</p>
        </div>
      )
    } else {
      return this.props.children;
    }
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/components/ErrorBoundary.jsx